import React from 'react'
import DeleteModal from './DeleteModal'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { deleteArticle, clearArticle } from 'modules/knowledgebase/actions'

import { getArticle } from 'modules/knowledgebase/selectors';

import './style.css'

const DeleteArticleContent = ({ article, actions, onCloseModal, isFromEditor }) => (
  <DeleteModal
    onCloseModal={() => { 
      onCloseModal()
      actions.clearArticle()
    }}
    onDelete={() => {
      const payload = {
        article,
        isFromEditor
      }
      actions.deleteArticle(payload)
      onCloseModal()
    }}
    onCancel={
      onCloseModal
    }
    title="You're about to delete this article."
    body="Deleting this article will remove it from your public knowledgebase, and any links referencing this article will no longer be valid."
  />
)

const mapStateToProps = state => ({
  article: getArticle(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    deleteArticle,
    clearArticle
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteArticleContent)